import api from './api.js';
import util from '../util.js';

var Promise = util.getPromise();

/**
 * actions setup changes to state: they can be async
 * and typically contain groups of mutations.
 * @module actions
 */
export default {

    /**
     * loads a single event into state
     * @param {object} payload
     * @param {string} payload.url the url of the event to be loaded
     * @returns {promise} - resolves as true when event is loaded
     */
    loadSingleEvent({ dispatch, commit }, payload) {

        return new Promise((resolve, reject) => {

            // get event, and resolve or reject promise
            // based on the results
            api.getEvent(payload.url).then(response => {
                if (response.status === 'OK') {
                    commit('forceCurrentEventData', { eventData: response.data[0] })
                    console.log('can resolve');
                    resolve(response);
                } else {
                    reject("Could not load event");
                }
            });

        });
    },


    /**
     * acts as a single interface for loading a single event
     * @param {object} payload
     * @param {string} payload.url the url of the event to be loaded
     * @returns {promise} - resolves as true when event is loaded
     */
    appLoadPipelineSingleEvent({ dispatch, commit }, payload) {
        console.dir(dispatch('loadSingleEvent', payload));
        return dispatch('loadSingleEvent', payload)
            .then(() => {
                return dispatch({
                    type: 'ensureRequiredModulesAreLoaded'
                })
            })
            .then(() => {
                dispatch({
                    type: 'checkForSingleLoadedModule'
                })

                return dispatch({
                    type: 'orderModules'
                });
            })
            .then(() => {
                console.log('app load pipeline complete');
            })
    },

    /**
     * acts as a single interface for responding to app loads
     * @returns {promise} - resolves as true when all actions are completed
     */
    appLoadPipeline({ dispatch }, payload) {
        console.log('app load pipeline started');

        return dispatch('ensureEventsExist')
            .then(() => {
                // we include this here because it can run async or event ordering
                dispatch('orderEvents');

                return dispatch({
                    type: 'setUrlToState',
                    requestedUrl: payload['requestedUrl']
                });
            })
            .then(() => {
                return dispatch({
                    type: 'ensureRequiredModulesAreLoaded'
                })
            })
            .then(() => {
                return dispatch({
                    type: 'orderModules'
                });
            })
            .then(() => {
                return dispatch({
                    type: 'loadDivisionalInformation'
                })
            })
            .then(() => {
                return dispatch({
                    type: 'setLastLoadedEvent'
                });
            })
            .then(() => {
                console.log('app load pipeline complete');
            })
    },


    /**
     * Checks that events exist, and if they don't loads them
     * @returns {promise} returns true when events are confirmed to exist
     */
    ensureEventsExist({ dispatch, state }) {

        // we'll return some kind of promise no matter what
        let returnPromise = util.getEmptyPromise();

        // if we don't yet have events, we should get them
        if (util.objectIsEmpty(state.events)) {
            returnPromise = dispatch('loadEvents');
        }

        return returnPromise;
    },


    /**
     * loads events into state
     * @returns {promise} returns data on events when they are loaded
     */
    loadEvents({ commit }) {
        return new Promise((resolve, reject) => {

            // get events, and resolve or reject promise
            // based on the results
            api.getEvents({}).then(data => {
                if (data.status === 'OK') {
                    commit('setEvents', data.data)
                    resolve(data);
                } else {
                    reject("Could not load events");
                }
            });

        });

    },

    
    
    loadDivisionalInformation({ commit }) {
        return new Promise((resolve, reject) => {
            api.getDivisionalInformation({}).then(data => {
                if (data.status === 'OK') {
                    commit('setDivisionalInformation', data)
                    resolve(data);
                } else {
                    reject("Could not load divisional Information");
                }
            });
        })
    },

    /**
     * moves data for events into appropriate data structures
     * @returns {promise} returns true when events are ordered
     */
    orderEvents({ commit }) {
        return new Promise((resolve) => {
            commit('setDateOrderEvents');
            commit('setNameOrderEvents');
            resolve(true);
        });
    },


    /**
     * sets url to state
     * @param {string} requestedUrl - the current url
     * @returns {promise} returns true when url is commited to state
     */
    setUrlToState({ commit }, payload) {
        return new Promise((resolve) => {
            commit('setCurrentEventUrl', payload['requestedUrl']);
            resolve(true);
        });
    },


    /**
     * loads the modules of the current event
     */
    loadModules({ commit, state }) {
        console.log('load');        
        return api.getModules({            
            event_id: state.currentSingleEvent['id']
        }).then(data => {
            console.dir(`loaded data ${data}`);
            commit(
                'setModules',
                {
                    modules: data.data
                }
            )
        });
    },


    /**
     * ensures that modules are loaded as required
     * @returns {promise} returns data on modules when they are loaded
     */
    ensureRequiredModulesAreLoaded({ dispatch, commit, state }) {
        console.log('ensure')
        return new Promise((resolve, reject) => {
            // commit('setCurrentEvent');
            dispatch({
                type: 'loadModules',
            }).then(() => {
                resolve(true);
            }).catch(() => {
                console.log('failed to load modules');
                reject(false);
            });
        });
    },


    /**
     * moves data for modules into appropriate data structures
     * @returns {promise} returns true when modules ahve been ordered
     */
    orderModules({ commit }) {
        return new Promise(resolve => {
            commit(
                'setModuleDayDateOrder'
            );

            commit(
                'setDateModules'
            );

            resolve(true);
        });
    },


    /**
     * sets the last loaded event on state
     * @returns {promise} returns true when state has been set
     */
    setLastLoadedEvent({ commit }) {
        return new Promise(resolve => {
            commit('setLastLoadedEvent');

            resolve(true);
        });
    },

    /**
     * sets the selected modules
     * @returns {promise}
     */
    setSelectedModules({ commit }, payload) {
        return new Promise(resolve => {
            commit('setSelectedModules', payload['modules']);
            commit('setClashingModules');

            resolve(true);
        });
    },


    /**
     * sets the firstname property of state
     * @returns {promise}
     */
    setFirstname({ commit }, payload) {
        return new Promise(resolve => {
            commit('setFirstname', payload['firstname']);
            resolve(true);
        });
    },


    /**
     * sets the surname property of state
     * @returns {promise}
     */
    setSurname({ commit }, payload) {
        return new Promise(resolve => {
            commit('setSurname', payload['surname']);
            resolve(true);
        });
    },

    /**
     * sets the email property of state
     * @returns {promise}
     */
    setEmail({ commit }, payload) {
        return new Promise(resolve => {
            commit('setEmail', payload['email']);
            resolve(true);
        });
    },

    /**
     * sets the postcode property of state
     * @returns {promise}
     */
    setPostcode({ commit }, payload) {
        return new Promise(resolve => {
            commit('setPostcode', payload['postcode']);
            resolve(true);
        });
    },

    /**
     * sets the dataProtection property on state
     * @returns {promise}
     */
    setDataProtection({ commit }, payload) {
        return new Promise(resolve => {
            commit('setDataProtection', payload['dataProtection']);
            resolve(true);
        });
    },

    
    /**
     * sets the emailOptin property on state
     * @returns {promise}
     */
    setEmailOptin({ commit }, payload) {
        return new Promise(resolve => {
            commit('setEmailOptin', payload['emailOptin']);
            resolve(true);
        });
    },


    /**
     * sets the highestQualification property on state
     * @returns {promise}
     */
    setHighestQualification({ commit }, payload) {
        return new Promise(resolve => {
            commit('setHighestQualification', payload['highestQualification']);
            resolve(true);
        });
    },

    /**
     * sets the divisionalInformation property on state
     * @param {*} param0 
     * @param {*} payload 
     * @returns 
     */
    setDivisionalInformation({ commit }, payload) {
        console.log('payload from actions' + payload);
        return new Promise(resolve => {
            commit('setDivisionalInformation', payload['divisionalInformation']);
            resolve(true);
        });
        },
    

     /**
     * sets the current study programme of state
     * @returns {promise}
     */
      setCurrentStudyProgramme({ commit }, payload) {
        return new Promise(resolve => {
            commit('setCurrentStudyProgramme', payload['currentStudyProgramme']);
            resolve(true);
        });
    },

    /**
     * sends the registration details
     * @returns {promise} returns data when submisssion is done
     */
    sendRegistration({ state }) {
        let userData = {
            firstname: state.firstname,
            surname: state.surname,
            email: state.email,
            postcode: state.postcode,
            dataProtection: state.dataProtection,
            emailOptin: state.emailOptin,
            highestQualification: state.highestQualification,
            divisionalInformation: state.divisionalInformation,
            currentStudyProgramme: state.currentStudyProgramme
        };

        let eventData = {
            event: state.currentSingleEvent.id,
            modules: state.selectedModules,
        };

        return api.sendRegistration({
            userData,
            eventData,
        });
    },


    /**
     * responds to the returned data from a request to register
     * @returns {promise} returns when response is done.
     */
    handleRegistrationResponse({ state, commit }, payload) {
        if (payload['error']) {
            commit('clearSelectedModules');
        } else {
            if (payload['registered']) {
                console.log('registered check');
                window.dataLayer.push({
		              'event': 'Event registered'
	              });
                console.log('event registered')
                // set state to registered
                // app can watch that and then go to confirm
                commit('setRegisteredStatus', payload)
                
            } else {

            }
        }
    },

    /**
     * if an event only has one module, preload it as selected
     */
    checkForSingleLoadedModule({ state, commit }) {
        console.log('checking for single event')

        if (Object.keys(state.modules).length === 1) {
            console.log('has only one module')
            commit('setSelectedModules', [Object.keys(state.modules)[0]])
            console.log('other side')
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js